/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/label-has-for */

import React from 'react';
import moment from 'moment';

import TooltipForReceptionist from 'components/TooltipForReceptionist';
import IN from 'constants/in';

import Switcher from 'onboarding/common/forms/checkboxPopup/Switcher';

export class OpeningHours extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="content">
        {!this.props.settingsLayout && (
          <div className="border-top-title cfix">
            <div className="form-horizontal col-lg-6">
              <div className="row">
                <div className="settings-heading col-xs-9">
                  <div className="row">
                    <label>Salon Opening Hours</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="salon-opening-hours-layout">
          <div className="t-container-hours relative">
            <Switcher
              dayName="Monday"
              isOpen={this.props.salonDetails.mon_open}
              openTime={moment(this.props.salonDetails.mon_open_time, 'HH:mm:ss')}
              closeTime={moment(this.props.salonDetails.mon_close_time, 'HH:mm:ss')}
              onOpenCheckboxChange={this.props.onOpenCheckboxChange}
              onOpenTimeChange={this.props.onOpenTimeChange}
              onCloseTimeChange={this.props.onCloseTimeChange}
            />
            <TooltipForReceptionist where={IN.hours} />
          </div>
          <div className="t-container-hours relative">
            <Switcher
              dayName="Tuesday"
              isOpen={this.props.salonDetails.tue_open}
              onOpenCheckboxChange={this.props.onOpenCheckboxChange}
              openTime={moment(this.props.salonDetails.tue_open_time, 'HH:mm:ss')}
              closeTime={moment(this.props.salonDetails.tue_close_time, 'HH:mm:ss')}
              onOpenTimeChange={this.props.onOpenTimeChange}
              onCloseTimeChange={this.props.onCloseTimeChange}
            />
            <TooltipForReceptionist where={IN.hours} />
          </div>
          <div className="t-container-hours relative">
            <Switcher
              dayName="Wednesday"
              isOpen={this.props.salonDetails.wed_open}
              onOpenCheckboxChange={this.props.onOpenCheckboxChange}
              openTime={moment(this.props.salonDetails.wed_open_time, 'HH:mm:ss')}
              closeTime={moment(this.props.salonDetails.wed_close_time, 'HH:mm:ss')}
              onOpenTimeChange={this.props.onOpenTimeChange}
              onCloseTimeChange={this.props.onCloseTimeChange}
            />
            <TooltipForReceptionist where={IN.hours} />
          </div>
          <div className="t-container-hours relative">
            <Switcher
              dayName="Thursday"
              isOpen={this.props.salonDetails.thu_open}
              onOpenCheckboxChange={this.props.onOpenCheckboxChange}
              openTime={moment(this.props.salonDetails.thu_open_time, 'HH:mm:ss')}
              closeTime={moment(this.props.salonDetails.thu_close_time, 'HH:mm:ss')}
              onOpenTimeChange={this.props.onOpenTimeChange}
              onCloseTimeChange={this.props.onCloseTimeChange}
            />
            <TooltipForReceptionist where={IN.hours} />
          </div>
          <div className="t-container-hours relative">
            <Switcher
              dayName="Friday"
              isOpen={this.props.salonDetails.fri_open}
              onOpenCheckboxChange={this.props.onOpenCheckboxChange}
              openTime={moment(this.props.salonDetails.fri_open_time, 'HH:mm:ss')}
              closeTime={moment(this.props.salonDetails.fri_close_time, 'HH:mm:ss')}
              onOpenTimeChange={this.props.onOpenTimeChange}
              onCloseTimeChange={this.props.onCloseTimeChange}
            />
            <TooltipForReceptionist where={IN.hours} />
          </div>
          <div className="t-container-hours relative">
            <Switcher
              dayName="Saturday"
              isOpen={this.props.salonDetails.sat_open}
              onOpenCheckboxChange={this.props.onOpenCheckboxChange}
              openTime={moment(this.props.salonDetails.sat_open_time, 'HH:mm:ss')}
              closeTime={moment(this.props.salonDetails.sat_close_time, 'HH:mm:ss')}
              onOpenTimeChange={this.props.onOpenTimeChange}
              onCloseTimeChange={this.props.onCloseTimeChange}
            />
            <TooltipForReceptionist where={IN.hours} />
          </div>
          <div className="t-container-hours relative">
            <Switcher
              dayName="Sunday"
              isOpen={this.props.salonDetails.sun_open}
              onOpenCheckboxChange={this.props.onOpenCheckboxChange}
              openTime={moment(this.props.salonDetails.sun_open_time, 'HH:mm:ss')}
              closeTime={moment(this.props.salonDetails.sun_close_time, 'HH:mm:ss')}
              onOpenTimeChange={this.props.onOpenTimeChange}
              onCloseTimeChange={this.props.onCloseTimeChange}
            />
            <TooltipForReceptionist where={IN.hours} />
          </div>
        </div>
      </div>
    );
  }
}

export default OpeningHours;
